
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TableBody, TableCell, TableHead, TableRow,  Typography, Stack, Pagination } from "@mui/material";
import { BackdropScreen, MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { descargarPDF } from "../../../helpers/descargarArchivo";
import { LayoutTabla } from "../../layouts";
import { descargarSoloCotizacion, eliminarCotizacion, generarOpDesdeCotizacion } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";

import Swal from "sweetalert2";
import dayjs from "dayjs";
const paginado = Number(process.env.REACT_APP_PAGINADO);




export const TablaListadoCotizaciones = ({ data, chagePage, page }) => {


    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const [cargando, setCargando] = useState(false);



    const handleUploadCotizacion = async (co) => {
        const titulo = `Cotizacion-${co.usuario.nombre}`
        setCargando(true);
        const datos = await descargarSoloCotizacion(co.id);
        setCargando(false);
        descargarPDF(datos, titulo);
    }



    const handleEnviarAlCarrito = async (cotizacion) => {
        const { value } = await Swal.fire({
            title: 'Importante',
            text: `Los productos actuales del carrito serán eliminados para cargar estos nuevos. ¿Deseas seguir?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        });
        if( !value ) return;

        const resp = await generarOpDesdeCotizacion({id: cotizacion.id});
        if(resp){
            navigate(`/super/comprar-ahora`);
            queryClient.invalidateQueries({ queryKey: ['carritoxuser'] });
        }
    }




    const hendleDelete = async(id) => {
        const { value } = await Swal.fire({
            title: 'Eliminar Cotización',
            text: `¿Esta seguro de eliminar esta cotización?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        });
        if( !value ) return;

        const resp = await eliminarCotizacion(id);
        if(resp){
            queryClient.invalidateQueries({ queryKey: ['todas-cotizaciones'] });
        }
    }




    return (

        <>
        <BackdropScreen cargando={cargando} titulo='Espere por favor estamos generando su cotización...' />
        
        {(data?.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(70 / +paginado)} disabled={Math.ceil(70 / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'10%'}}>Cotizacion</TableCell>
                        <TableCell sx={{width:'15%'}}>Fecha</TableCell>
                        <TableCell sx={{width:'20%'}}>Usuario</TableCell>
                        <TableCell sx={{width:'15%'}}>Rol</TableCell>
                        <TableCell sx={{width:'15%'}}>Estado</TableCell>
                        <TableCell sx={{width:'10%'}}># Items</TableCell>
                        <TableCell sx={{width:'15%'}}>Acciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {data.map((co) => (
                    <TableRow  key={ co.id }>  
                        <TableCell >{ co.cotizacion }</TableCell>
                        <TableCell><Typography variant="span">{ dayjs(co.fechaFactura).format('ll') }</Typography></TableCell>
                        <TableCell>{co.usuario?.nombre}</TableCell>
                        <TableCell><Typography variant="span" >{ co.tipoRol }</Typography></TableCell>
                        <TableCell>
                            <Typography variant="span" sx={{fontWeight:'bold', color:co.estado === 'ACTIVA' ? 'white' : 'error' }}>
                                { co.estado }
                            </Typography>
                        </TableCell>
                        <TableCell>{co.items.length}</TableCell>

                        <TableCell sx={{display:'flex', justifyContent:'center'}}>
                            <Stack spacing={1} direction="row">
                                <TooltipAndIcon
                                    titulo="Descargar cotización"
                                    icono="descargar"
                                    color="white"
                                    onClick={ () => handleUploadCotizacion(co) }
                                />  

                                <TooltipAndIcon
                                    titulo="Comprar Ahora"
                                    icono="comprar"
                                    color="white"
                                    onClick={ () => handleEnviarAlCarrito(co) }
                                /> 

                                <TooltipAndIcon
                                    titulo="Eliminar cotización"
                                    icono="eliminar"
                                    color="white"
                                    onClick={ () => hendleDelete(co.id) }
                                /> 
                            </Stack>
                        </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </LayoutTabla>

        :   <MensajeAlertaDanger titulo='No hay cotizaciones disponibles' />
        }
        </>
    )
}
